import { actionTypes } from './actions';
import { reducer as form } from 'redux-form';

export function rememberMe(state = false, action) {
  switch (action.type) {
    case actionTypes.SET_REMEMBER_ME:
      return action.rememberMe;
    default:
      return state;
  }
}

export function thirdPartyLoginError(state = '', action) {
  switch (action.type) {
    case actionTypes.SET_THIRD_PARTY_LOGIN_ERROR:
      return action.error;
    default:
      return state;
  }
}

export function userInfo(state = {}, action) {
  switch (action.type) {
    case actionTypes.SET_USER_INFO:
      return action.userInfo;
    default:
      return state;
  }
}

export default {
  form,
  rememberMe,
  thirdPartyLoginError,
  userInfo
};
